export default "__VITE_ASSET__BAC516iJ__"